var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSpeedTestDarkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.057 24.527c0-5.292 4.451-9.582 9.943-9.582c2.551 0 4.878 .926 6.638 2.448l.427-0.338c.229-0.195 .938-0.611 1.539-0.029c.534 .518 .168 1.021 0 1.184l-0.467 .589c-0.029 .037-0.055 .075-0.078 .115c1.186 1.577 1.884 3.517 1.884 5.613c0 .814 .685 1.473 1.529 1.473c.844 0 1.528-0.659 1.528-1.473c0-6.918-5.82-12.527-13-12.527c-7.18 0-13 5.609-13 12.527c0 .814 .684 1.473 1.528 1.473c.844 0 1.529-0.659 1.529-1.473Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.331 17.923c.004-0.004 .009-0.008 .013-0.012c.208-0.208 .208-0.546 0-0.755c-0.209-0.208-0.547-0.208-0.755 0c-0.002 .002-0.003 .004-0.005 .005l-9.551 7.983l.002 .002c-0.019 .016-0.037 .033-0.054 .051c-0.641 .641-0.641 1.681 0 2.322c.641 .641 1.681 .641 2.322 0c.057-0.057 .11-0.118 .157-0.181l7.871-9.415Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeedTestDarkActive);
export default __webpack_public_path__ + "static/media/ic_speed_test_dark_active.9c9cbd3826646bcbc6fb51728d02685c.svg";
export { ForwardRef as ReactComponent };